import { Box, Typography } from "@mui/material"
import { colors } from "../../../../styles/commonStyles"

const GoalsCellColored = (props: any) => {
  const { row, renderedCellValue } = props

  const highlight = row?.original?.trend_highlighting?.toLowerCase()

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        // width: "50%",
        p: "3px",
        margin: "0 auto",
        backgroundColor: `${
          highlight == "red"
            ? colors.primaryRed
            : highlight == "yellow"
            ? colors.primaryYellow
            : highlight == "green"
            ? colors.primaryGreen
            : "#FFFFFF"
        }`,
        color: `${
          highlight == "red"
            ? "#FFFFFF"
            : highlight == "yellow"
            ? "#000000"
            : highlight == "green"
            ? "#FFFFFF"
            : "#000000"
        }`,
      }}
    >
      <Typography>{renderedCellValue}</Typography>
    </Box>
  )
}

export default GoalsCellColored
